import { defineMessages } from "react-intl";

const PREFIX = "ExpiredPasswordLinkPage";
export default defineMessages({
    checkMail: {
    id: `${PREFIX}.checkMail`,
    defaultMessage:
      "Please, check your mail for the password change link. The link will be valid for 7 days.",
  }
});